import { MenuItem, Stack, TextField, Typography } from '@cmg/design-system';
import { createIntl, type LocaleCode } from '@cmg/i18n';
import { ChangeEvent } from 'react';

export type Props = {
  value: LocaleCode;
  onChange: (event: ChangeEvent) => void;
};

const localeOptions: Array<{ value: LocaleCode; label: string }> = [
  { value: 'en-US', label: 'United States' },
  { value: 'en-GB', label: 'United Kingdom' },
];

const formatExamples = (locale: LocaleCode): string => {
  const intl = createIntl({ preferredLanguages: [locale] });
  const today = new Date();
  const short = intl.formatDate(today, { format: 'short' });
  const standard = intl.formatDate(today, { format: 'standard' });
  const literal = intl.formatDate(today, { format: 'literal' });
  return `Format Examples: ${short}; ${standard}; ${literal}`;
};

const RegionsSettings: React.FC<Props> = ({ onChange, value }) => (
  <Stack gap={2}>
    <Typography variant="h4">Region</Typography>
    <Typography variant="body1" color="text.secondary">
      CMG uses your regional settings to display dates and numbers in your local format.
    </Typography>
    <TextField
      id="locale"
      name="locale"
      select
      label="Region Format"
      value={value}
      onChange={onChange}
      helperText={formatExamples(value)}
      sx={{ maxWidth: 340 }}
    >
      {localeOptions.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  </Stack>
);

export default RegionsSettings;
